import { render, staticRenderFns } from "./monedasEdit.vue?vue&type=template&id=212a1f62&"
import script from "./monedasEdit.vue?vue&type=script&lang=js&"
export * from "./monedasEdit.vue?vue&type=script&lang=js&"
import style0 from "./monedasEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports